import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomerInfoContext } from '../../../contexts/CustomerInfoContext';
import { resources } from '../../../resources/resources';
import { ContestsBanner } from './ContestsBanner';

export const visitedContestIdsKey = 'visitedContestIds';

export const Contest = () => {
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);
  const contests = customerInfo.contests || [];

  if (!contests.length) return null;

  return (
    <section className="page-section mb-60">
      <h2 className="section-title">
        {translate(resources.contests.contests)}
      </h2>
      <ContestsBanner contests={contests} />
    </section>
  );
};
